import type {ReactElement, Ref} from 'react';
import React from 'react';
import {ClickableDiv} from '@Components/clickable-div';
import {Text, TextSize} from '@Components/text';
import styles from './nav-dropdown-selector.module.scss';

interface NavDropdownSelectorProps {
  className?: string;
  isSelected?: boolean;
  text: string;
  onClick?(): void;
}

const NavDropdownSelector = React.forwardRef(
  ({isSelected = false, className = '', onClick = (): void => {}, ...props}: NavDropdownSelectorProps, ref: Ref<HTMLDivElement>): ReactElement<any> => {
    return (
      <ClickableDiv
        ref={ref}
        className={`${styles.selector} flex-center radius-4 ${isSelected ? styles.selected : ''} ${className}`}
        onClick={(): void => {
          onClick();
        }}
      >
        <Text val={props.text} size={TextSize.XSMALL} bold />
      </ClickableDiv>
    );
  }
);

export default NavDropdownSelector;
